var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", { attrs: { name: "modal-switcher", width: 650 } }, [
    _c("p", { attrs: { slot: "header" }, slot: "header" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("Choose your country")) + "\n  ")
    ]),
    _vm._v(" "),
    _c("div", { attrs: { slot: "content" }, slot: "content" }, [
      _c(
        "div",
        { class: { columns: _vm.enableColumns } },
        [
          _c("div", { staticClass: "country country-current" }, [
            _c("h3", [_vm._v(_vm._s(_vm.$t(_vm.fullCountryName)))]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _c("a", { attrs: { href: "/" } }, [
                  _vm._v(_vm._s(_vm.$t(_vm.fullLanguageName)))
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _vm._l(_vm.storeViews, function(storeView, storeCode) {
            return _c(
              "div",
              { key: storeCode, staticClass: "country country-available" },
              [
                _c("h3", [
                  _vm._v(_vm._s(_vm.$t(storeView.i18n.fullCountryName)))
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _c("a", { attrs: { href: storeView.url } }, [
                      _vm._v(_vm._s(_vm.$t(storeView.i18n.fullLanguageName)))
                    ])
                  ])
                ])
              ]
            )
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }